__turbopack_context__.v({
  "actionList": "ErrorPage-module-scss-module__C7xZga__actionList",
  "code": "ErrorPage-module-scss-module__C7xZga__code",
  "content": "ErrorPage-module-scss-module__C7xZga__content",
  "description": "ErrorPage-module-scss-module__C7xZga__description",
  "fade-in": "ErrorPage-module-scss-module__C7xZga__fade-in",
  "no-transform": "ErrorPage-module-scss-module__C7xZga__no-transform",
  "rotate": "ErrorPage-module-scss-module__C7xZga__rotate",
  "section": "ErrorPage-module-scss-module__C7xZga__section",
  "summary": "ErrorPage-module-scss-module__C7xZga__summary",
});
